var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.25C6.20435 0.25 5.44129 0.56607 4.87868 1.12868C4.31607 1.69129 4 2.45435 4 3.25C4 4.04565 4.31607 4.80871 4.87868 5.37132C5.44129 5.93393 6.20435 6.25 7 6.25C7.79565 6.25 8.55871 5.93393 9.12132 5.37132C9.68393 4.80871 10 4.04565 10 3.25C10 2.45435 9.68393 1.69129 9.12132 1.12868C8.55871 0.56607 7.79565 0.25 7 0.25ZM7 8.5C4.747 8.5 0.25 9.631 0.25 11.875V13C0.25 13.414 0.586 13.75 1 13.75H13C13.414 13.75 13.75 13.414 13.75 13V11.875C13.75 9.631 9.253 8.5 7 8.5Z",
    fill: "#458C42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active_users.82c8caa7fa8ecd6078b4625521931690.svg";
export { ForwardRef as ReactComponent };